import type { BadgeTone } from '@/components/ui/badge'

export const ORDER_STATUSES = ['pending', 'confirmed', 'processing', 'shipped', 'delivered', 'cancelled'] as const

export type OrderStatus = typeof ORDER_STATUSES[number]

export const ORDER_STATUS: Record<OrderStatus, { ar: string, en: string, tone: BadgeTone }> = {
    pending: { ar: 'جديد', en: 'New', tone: 'amber' },
    confirmed: { ar: 'مؤكد', en: 'Confirmed', tone: 'cyan' },
    processing: { ar: 'قيد التجهيز', en: 'Preparing', tone: 'violet' },
    shipped: { ar: 'تم الشحن', en: 'Shipped', tone: 'navy' },
    delivered: { ar: 'تم التسليم', en: 'Delivered', tone: 'green' },
    cancelled: { ar: 'ملغي', en: 'Cancelled', tone: 'red' }
}

export const toOrderStatus = (value: unknown): OrderStatus =>
    typeof value === 'string' && (ORDER_STATUSES as ReadonlyArray<string>).includes(value) ? value as OrderStatus : 'pending'
